import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/");
      return;
    }
    const sid = m[1];
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sid });
        // Store session_token as fallback Bearer (covers cookie-blocked scenarios on custom domains)
        if (r.data?.session_token) {
          localStorage.setItem("session_token", r.data.session_token);
        }
        setUser(r.data.user);
        // If user was mid-way through pro registration, send to the profile form
        const proKind = localStorage.getItem("pro_reg_kind");
        const target = proKind ? "/iscriviti/scheda" : "/dashboard";
        window.history.replaceState({}, "", target);
        navigate(target, { replace: true, state: { user: r.data.user } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#2563EB] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-sm text-slate-600 font-ui">Autenticazione in corso...</p>
      </div>
    </div>
  );
}
